var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOn = function SvgEyeOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8A8AA3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.27 7.081c3.063 2.406 2.98 4.594 2.98 4.919 0 1-1.75 6.25-7.25 6.25-.731 0-3.272-.361-4.949-1.938M7 16.269c-1.638-1.6-2.25-3.678-2.25-4.269 0-1 1.75-6.25 7.25-6.25 1.795 0 3.19.559 4.256 1.347m-2.61 6.39c-1.783 1.53-3.339-.003-3.385-.06a2.25 2.25 0 0 1 .148-3.018c.773-.773 2.046-.773 2.92-.187.121.08 1.535 1.45.35 3.252"
  })));
};
export default SvgEyeOn;